import { Play } from "lucide-react";
import Register from "@/components/landing/Register";

export default function Hero({ onWatch, onStart }) {
  return (
    <section id="anasayfa" className="relative bg-white pt-[68px]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 items-center py-12 lg:py-16">
          {/* Left: text */}
          <div>
            <h1 className="font-extrabold text-brand tracking-tight text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
              <span className="block">TÜRKİYE</span>
              <span className="block mt-1">BORSASI</span>
            </h1>

            <p className="mt-5 text-2xl sm:text-3xl font-bold text-brand">
              Güçlü Geçmiş, Güvenli Gelecek
            </p>

            <p className="mt-6 max-w-xl text-slate-600 text-base sm:text-lg leading-relaxed">
              Türkiye'nin sermaye piyasalarının kalbi olan Borsa İstanbul, yatırımcılar ile şirketleri
              buluşturan, ekonomik büyümeyi destekleyen ve ülke ekonomisinin gelişimine katkı sağlayan
              en önemli finans merkezidir.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                data-testid="hero-cta-start"
                href="#kayit"
                className="rounded-md bg-brand px-7 py-3.5 text-white font-bold text-sm tracking-wide transition-all duration-300 hover:bg-brand-dark hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(30,95,180,0.35)]"
              >
                YATIRIMA BAŞLA
              </a>
              <button
                data-testid="hero-cta-video"
                onClick={onWatch}
                className="group inline-flex items-center gap-2.5 rounded-md bg-brand px-6 py-3.5 text-white font-bold text-sm tracking-wide transition-all duration-300 hover:bg-brand-dark hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(30,95,180,0.35)]"
              >
                <Play className="w-4 h-4 fill-white" />
                EĞİTİM VİDEOSU
              </button>
            </div>
          </div>

          {/* Right: registration form */}
          <div className="relative">
            <Register onWatch={onWatch} />
          </div>
        </div>
      </div>
    </section>
  );
}
